import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from 'vuex-persistedstate';

import meta from "./modules/meta.js";

// import authModule from '@/stores/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  // plugins: [createPersistedState({
  //   paths: ['auth','rememberMe']
  // })],
  state: {
    isLoading: true,
    isSos: false
    // menuActive: false,
  },
  mutations: {
    SET_LOADING_STATUS(state, status) {
      state.isLoading = status;
    },
    SET_SOS_STATUS(state, status) {
      state.isSos = status;
    }
    // SET_MENU_STATUS(state, status) {
    //   state.menuActive = status;
    // }
  },
  modules: {
    meta
    // auth: authModule,
  }
});
